module.exports = __webpack_public_path__ + "static/media/stop-start.4fd5427e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/stop-start.svg
// module id = 943
// module chunks = 0